module.exports = __webpack_public_path__ + "img/logo.254d60b9.svg";